import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonAddToBetslipProps: CustomButtonProps = {
  variant: 'secondary',
  height: '38px',
  fontWeight: 'bold',
  fontSize: 'xs',
};
export const FlexWrapper: CSSObject = {
  bg: 'blackAlpha.400',
  borderBottomRadius: 'md',
  px: ['3', null, '2.5'],
  '&&': {
    py: '3',
  },
};
export const FlexInputWrapper: CSSObject = {
  label: {
    color: 'white',
    fontWeight: 'semibold',
    fontSize: 'xs',
  },
  '.chakra-form__label': {
    color: 'white',
  },
  '.chakra-input__group': {
    borderRadius: 'md',
    bgGradient: 'linear(to-b, alpha.100 0%, alpha.500 100%)',
    border: 'none',
  },
  '.chakra-input__left-addon': {
    bg: 'beta.300',
    h: 'auto',
    border: 'none',
    fontWeight: 'bold',
  },
};
export const SelectionPopupContainer: CSSObject = {
  mt: '2.5',
  mx: [0, null, '-3'],
  mb: [0, null, '-6'],
  bg: 'alpha.500',
  borderBottomRadius: ['none', null, 'md'],
  zIndex: '10',
};
export const InfoHeader: CSSObject = {
  h: '9',
  alignItems: 'center',
  px: '4',
  py: '3',
  borderTop: '3px solid',
  borderTopColor: 'beta.300',
  borderBottom: '1px solid',
  borderBottomColor: 'whiteAlpha.300',
};
export const InfoText: CSSObject = {
  _first: {
    fontSize: 'sm',
    color: 'white',
    fontFamily: 'heading',
    fontWeight: 'normal',
  },
  _last: {
    fontSize: 'sm',
    color: 'white',
    fontFamily: 'heading',
    fontWeight: 'normal',
  },
};
export const TextAddToBetslipButton: CSSObject = {
  w: '267px',
  fontWeight: 'bold',
};

export const toteMultiListSelections: CSSObject = {
  color: 'white',
  px: '4',
  py: '3',
  display: 'flex',
  fontSize: 'sm',
  fontWeight: 'bold',
  borderBottom: '1px dashed',
  borderColor: 'white',

  sx: {
    '.toteMultiLegNum': {
      mr: '8',
      '& + p > span': {
        ml: '2',
        fontWeight: 'normal',
      },
    },
    '&.last-element': {
      borderBottom: 'none',
    },
  },
};

export const toteMultiListSelectionsIcon: CSSObject = {
  mt: '-3px',
  width: '24px',
  height: '24px',
  color: 'white',
};
